/**
 * Usage:
 *
 *   data-sw-product-shopper-description=<SPIN>
 *
 * Selector for Product Configuration description:
 *   data-sw-product-shopper-description-text
 *
 * Selector for Product Item (usually stock item:
 *   data-sw-product-shopper-description-text-pi
 *
 */

var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {
  $fragment.swFindWithSelf('[data-sw-product-shopper-description]').each(function() {
    var that = this;

    require([
      'js/lib/models/ModelManager',
      'rrViewComponents/Product/ProductShopperDescriptionComponent/ProductShopperDescription'
    ], function(ModelManager, ProductShopperDescription) {
      var $el = $(that);
      var spin = $el.attr('data-sw-product-shopper-description');

      new ProductShopperDescription({
        model: ModelManager.getProduct(spin),
        el: $el
      });
    });
  });
};
